/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Vereinbarungsnotitzschule1Inputs */

const de__field_vereinbarungsnotitzschule1 = /** @type {(inputs: _Field_Vereinbarungsnotitzschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinbarung Notiz Schule`)
};

/**

* @param {_Field_Vereinbarungsnotitzschule1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_vereinbarungsnotitzschule1 = /** @type {((inputs?: _Field_Vereinbarungsnotitzschule1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Vereinbarungsnotitzschule1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_vereinbarungsnotitzschule1(inputs)
});
export { _field_vereinbarungsnotitzschule1 as "_field_vereinbarungsnotitzSchule" }